var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 13,
    viewBox: "0 0 63 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0588 0.00428859C18.5214 0.262295 13.1765 12.5668 0 13H63C46.9412 12.5669 42.2598 -0.268556 30.0588 0.00428859Z",
    fill: "#8BB1DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveMenu);
export default __webpack_public_path__ + "static/media/wave-menu.2fce6497f07b42d68df9b22eec104baa.svg";
export { ForwardRef as ReactComponent };